import React from "react";
import { StaffNavigation } from "./components/Navigtaion";
import { RolesTab } from "@/components/pages/users/components/RolesTab";
import { Role } from "@/types/user";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { hasFrontdeskBlockPermission } from "@/utils/accessControl";

export const StaffRolesPage: React.FC = () => {
  const { userProfile } = useAuthenticatedUser();
  const canAddCustomRole = hasFrontdeskBlockPermission(
    userProfile,
    "frontdesk_management",
    "administrate",
  );

  return (
    <div className="flex h-full flex-col gap-6 p-6">
      <StaffNavigation activeTab="roles" />
      <RolesTab
        backTo={null}
        canAddCustomRole={canAddCustomRole}
        scope="tenant"
        allowedBaseRoles={[Role.FRONT_DESK]}
      />
    </div>
  );
};
